import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { UpdateDocumentAdditionalData, DOCUMENT_FIELD_UPDATE } from "./UpdateDocumentAdditionalData";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { JsonDataType } from "../../../../../utils/customInputMapping/JsonDataType";

export const updateDocumentJsonDataActionTypes = createRequestActionTypes('UPDATE_DOCUMENT_JSON_DATA')

export type UpdateDocumentJsonDataAdditionalData = UpdateDocumentAdditionalData & {
    ignoreResultTitle?: boolean
}
type Options = {
    ignoreResultTitle?: boolean
}
export const updateDocumentJsonData = (config: ApiConfig) => (docId: string, jsonDataField: JsonDataType, previewDescriptionJson?: string, checkAutomaticTitleOnChange?: boolean, options?: Options) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document, any, UpdateDocumentJsonDataAdditionalData> = {
        method: 'POST',
        requestActionTypes: updateDocumentJsonDataActionTypes,
        url: `${config.API_URL}/content/update-data-field?id=${encodeURIComponent(docId)}`,
        actionAdditionalData: {
            ...options,
            docId,
            updateInfo: {
                type: DOCUMENT_FIELD_UPDATE,
                data: jsonDataField
            }
        },
        processResultBeforeDispatch: (res) => {
            if (!!checkAutomaticTitleOnChange && config.updateItem) {
                config.updateItem('')
            }

            return res
        },
        body: {
            jsonData: JSON.stringify(jsonDataField),
            ...(previewDescriptionJson ? {previewDescriptionJson} : {})
        }
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}